import React from 'react';

function EmailAutomation({ color = '#335B70', color2, ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="M12 13L4 8V18H12C12 18.35 12.025 18.6875 12.075 19.0125C12.125 19.3375 12.2 19.6667 12.3 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V11.7C21.7 11.55 21.3792 11.425 21.0375 11.325C20.6958 11.225 20.35 11.15 20 11.1V8L12 13ZM12 11L20 6H4L12 11Z"
            />
            <path
                fill={color2 || color}
                d="M16.4099 22.45L16.9324 18.7925H14.3199L19.0224 12H20.0674L19.5449 16.18H22.6799L17.4549 22.45H16.4099Z"
            />
        </svg>
    );
}

export default EmailAutomation;
